import React from "react";
import themeLarge from "../ThemeLarge";
import ProjectProfile from "../project/ProjectProfile";

class RecentProjects extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      latestProject: props.latestProject,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.latestProject?.id !== this.props.latestProject?.id) {
      this.setState({ latestProject: this.props.latestProject });
    }
  }

  render() {
    const { latestProject } = this.state;
    const { totalProject } = this.props;

    return (
      <div
        className=""
        style={{
          background: themeLarge.colors.bg,
          paddingLeft: "100px",
          paddingRight: "100px",
          fontFamily: "Kumbh Sans",
          paddingBottom: "20px",
        }}
      >
        <div className="container">
          <div className="row">
            <p
              className="d-flex justify-content-center"
              style={{
                color: themeLarge.colors.text,
                fontSize: themeLarge.fontSize.h2,
              }}
            >
              {" "}
              Most Recent Project{" "}
            </p>

            <p
              className="d-flex justify-content-center"
              style={{
                fontSize: themeLarge.fontSize.small,
              }}
            >
              (Total Projects: {totalProject})
            </p>
          </div>

          {/* projects section. TODO: make it a separate new component */}
          <ProjectProfile latestProject={latestProject}></ProjectProfile>
        </div>
      </div>
    );
  }
}

export default RecentProjects;
